"use client";

import React from "react";
import { ArrowRight, Activity } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BlendBanner() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="blendhomogeneitybanner" data-nav="dark" className="relative overflow-hidden bg-sidebar text-sidebar-foreground py-16 sm:py-20 lg:py-24">
      {/* Subtle Background Pattern Accent */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-10">
        <div className="absolute -top-24 -left-24 size-96 rounded-full bg-primary/30 blur-3xl" />
        <div className="absolute -bottom-24 -right-24 size-96 rounded-full bg-sidebar-accent blur-3xl" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.08)_1px,transparent_1px)] [background-size:24px_24px]" />
      </div>

      <div className="page-container relative z-10">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="mx-auto max-w-3xl text-center flex flex-col items-center">
          {/* Subtle Category Pill */}
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-sidebar-border bg-sidebar-accent/50 px-3.5 py-1 text-xs font-medium text-sidebar-foreground">
            <Activity className="size-3.5 text-primary" />
            <span>Process Analytical Technology (PAT)</span>
          </div>

          {/* Heading */}
          <h2 className="text-3xl font-bold tracking-tight text-sidebar-foreground sm:text-4xl lg:text-5xl">
            Optimize Your Blend Homogeneity with Real-Time PAT
          </h2>

          <p className="mt-4 max-w-2xl text-base text-sidebar-foreground/80 sm:text-lg">
            Ensure rapid batch verification, uniform powder distribution, and regulatory compliance across manufacturing runs.
          </p>

          {/* Call to Action */}
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <Button asChild size="lg" className="bg-primary text-primary-foreground font-semibold shadow-md hover:bg-primary/90 focus-visible:ring-primary rounded-md px-6 py-3 text-base h-auto">
              <Link to="/ContactPage" className="inline-flex items-center gap-2">
                <span>Start Your PAT Journey</span>
                <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}